import {
  FETCH_DRIVERS_REQUEST,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  UPDATE_DRIVER_STATUS_REQUEST,
  UPDATE_DRIVER_STATUS_SUCCESS,
  UPDATE_DRIVER_STATUS_FAILURE,
} from '../actions/types';

const initialState = {
  drivers: [],
  loading: false,
  error: null,
  message: '',
};

// Reducer for handling driver actions
export default function driverReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DRIVERS_REQUEST:
    case UPDATE_DRIVER_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DRIVERS_SUCCESS:
      return {
        ...state,
        loading: false,
        drivers: action.payload,
        message: 'Drivers loaded successfully',
      };

    case FETCH_DRIVERS_FAILURE:
    case UPDATE_DRIVER_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DRIVER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        drivers: Array.isArray(state.drivers)
          ? state.drivers.map((driver) =>
            driver.driver_id === action.payload.driver_id
              ? { ...driver, ...action.payload } 
              : driver
          )
          : [],
        message: 'Driver status updated successfully',
      };


    default:
      return state;
  }
}
